import React, { ReactNode, ReactElement ,useRef,useEffect} from 'react';
import classNames from 'classnames/bind';
import { lruMemoize } from 'reselect';
import { connect } from 'react-redux';

import styles from './PlpHeader.pcss';
import luxeStyles from './Luxe/LuxePlpHeader.pcss';
import isArray from '../../utils/arrayUtils';
import { getColor } from '../../utils/style';
import { getCurrentStore } from '../../selectors/metaData';
import { getLuxeFlags } from '../../../Flags/selectors';

const mapStateToProps = state => ({
  name: getCurrentStore(state),
  luxeFlags: getLuxeFlags(state.flags)
});

const connector = connect(mapStateToProps);

const getStyles = lruMemoize((width: number) => ({
  flexBasis: `${width}%`
}));

export interface Config {
  component: ReactNode;
  width: number;
  action?: ((event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void) | undefined;
  testId?: string;
}

interface HeaderProps {
  getHeaderConfig: () => Config[];
  backgroundColor: string;
}

function Header(props: HeaderProps): ReactElement {
  const { headerConfig = [], backgroundColor, name, luxeFlags } = props;
  const backButtonRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    backButtonRef.current?.focus();
  }, []);

  const { isThemeEnable } = luxeFlags;
  const luxe = isThemeEnable === 'ON' && name === 'luxe';
  // const headerConfig = getHeaderConfig();
  if (!isArray(headerConfig)) {
    return <></>;
  }
  const cx = classNames.bind(styles);
  const luxecx = classNames.bind(luxeStyles);
  const containerClass = luxe ? luxecx('headerContainer') : cx('headerContainer');
  return (
    <div className={containerClass} style={getColor({ backgroundColor })}>
      {headerConfig.map(({ component, width, action, testId = '' }, index) => {
        const isBackIcon = testId === 'back-icon';
        return (
          <div
            key={`${testId}-${index}`}
            role="none"
            style={getStyles(width)}
            onClick={action}
            id={testId}
            ref={isBackIcon ? backButtonRef : null}
            tabIndex={isBackIcon ? 0 : undefined} 
          >
            {component}
          </div>
        );
      })}
    </div>
  );
}

export default connector(Header);
